import { GetterTree } from "vuex";
import { StateInterface } from "../index";
import { MedicationAdministratorState } from "@/interfaces/global/interfaces";

const getters: GetterTree<MedicationAdministratorState, StateInterface> = {};

export default getters;
